/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Submissions_TitleInputs */

const da_submissions_title = /** @type {(inputs: Submissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besvarelser`)
};

/** @type {(inputs: Submissions_TitleInputs) => LocalizedString} */
const en_submissions_title = da_submissions_title;

/**

* @param {Submissions_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const submissions_title = /** @type {((inputs?: Submissions_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submissions_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_submissions_title(inputs)
	return /** @type {LocalizedString} */ ("Besvarelser")
});